import { jsx as _jsx } from "react/jsx-runtime";
import { Box, FormControlLabel, Checkbox, } from '@mui/material';
import { clone } from 'lodash-es';
const MultipleChoiceAnswer = ({ availableAnswers, response, setResponse, disabled, }) => {
    const updateAnswers = (ev, answer) => {
        const newResponse = clone(response || []);
        if (ev.target.checked) {
            newResponse.push(answer.id);
        }
        else {
            const index = newResponse.indexOf(answer.id);
            if (index > -1) {
                newResponse.splice(index, 1);
            }
        }
        setResponse(newResponse);
    };
    return (_jsx(Box, { sx: { ml: 4 }, children: availableAnswers?.map((answer) => (_jsx(FormControlLabel, { id: answer.id, sx: {
                width: '80%',
                mt: 1,
            }, name: answer.id, label: answer.answerText, labelPlacement: "end", "aria-labelledby": `label-${answer.id}`, control: (_jsx(Checkbox, { sx: {
                    color: 'contract.main',
                    '&$checked': {
                        color: '#007bad',
                    },
                    '&$disabled': {
                        color: '#007bad',
                    },
                }, checked: response?.includes(answer.id), onChange: (ev) => updateAnswers(ev, answer), value: answer.id, disabled: disabled })) }, answer.id))) }));
};
export default MultipleChoiceAnswer;
//# sourceMappingURL=MultipleChoiceAnswer.js.map